import {
  Vue,
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Watch,
} from 'vue-property-decorator';
import { CreateElement, VNode } from 'vue';

/**
 * Control UniformScale
 */
@Component
export class TgUniformScale extends Vue {
  /**
   * The percentage number for depth-to-width ratio
   */
  @Prop({ type: [Number, String], default: '100%' })
  public readonly ratio!: number | string;

  public get style(): object {
    return {
      paddingBottom:
        typeof this.ratio === 'string' && this.ratio.endsWith('%')
          ? this.ratio
          : `${this.ratio}%`,
    };
  }

  private render(h: CreateElement): VNode {
    return (
      <div class="tg-uniform-scale" style={this.style}>
        <div class="tg-uniform-scale_container">{this.$slots.default}</div>
      </div>
    );
  }
}
